import * as React from 'react'

export const AccordionText = [
    {
        id: 1,
        heading: "Oil & Gas",
        content: "From BVO to BRV management and everything in between to give your business the edge to stay ahead with strong emphasis on safety and compliance."
    },
    {
        id: 2,
        heading: "Pharmacueticals", content: "Transport with complete control over the whole distribution chain to ensure that the medical supplies arrive to the consumer in  perfect conditions. Take the guess work out of your medical transportation service and streamline the entire chain with reliable technology to save lives."
    },
    {
        id: 3,
        heading: "Beverages",
        content: "Keep your product  on the shelves for your customers with an all intergated transport app whiles keeping eye on who, what  and where of your goods and asset. "
    },
    {
        id: 4,
        heading: "FMCG Distributors ",
        content: "With or without cross-docking service webbermill transport app will help with planning, timely delivery of goods and optimize your operations. "
    },
    {
        id: 5,
        heading: "General Transportation",
        content: "We understand it difficult to run a transport operation today without running on fast and flexible technology. Take advantage of our platform and transform your entire process of transporting. Government organisations, NGO's and corporations that operate their own transportation can leverage our app to transform respective departments."
    },
];



export const FAQText = [
    {
        id: 1,
        heading: "What makes our solution different from others?",
        content: "Our trip software is built on a reliable technology that makes it work seamlesly with proper security measures in place. All of our consultants have several years of experience within the oil industry and have a thorough understanding of its associated pains and needs. Additionally, our solutions are fully integrated, which makes your daily work stress-free and much more efficient."
    },
    {
        id: 2,
        heading: "Who owns my data, and is my data secure?",
        content: "We take data security seriously at Webbermill Limited. Our servers are hosted in a world-class data center that is protected by 24-hour surveillance, and we ensure that our application is always up to date with the latest security patches. Our partner's data centers are secure, and all our plans include SSL encryption to keep your data safe."
    },
    {
        id: 3,
        heading: "What support do I get?",
        content: "You can access our support by email or live chat in the application. We provide support and a robust community of help content to guide you through the use of our software. Click on “Support” in the footer navigation to access our knowledge base.  "
    },
    {
        id: 4,
        heading: "I need support during the weekend. Will I receive it?",
        content: "The weekend support is reserved only for Premium customers. We know that the weekend is commonly the best time to perform migrations or maintenance. Still, you will only get assistance from Webbermill support if you have a premium account (independently of the case’s priority). If you need help during the weekend, please get in touch with the Sales Team and upgrade your subscription right away!"
    },
    {
        id: 5,
        heading: "I’m not a technical person. Is this a problem?",
        content: "There is no problem with Webbermill Software not having technical skills. Customers are responsible for administering and setting up their own software. Webbermill Support will guide you on doing this. If you require further assistance, don’t hesitate to contact customer support."
    },
    {
        id: 6,
        heading: "Can I delete my account?",
        content: "Yes! You are free to delete your account or cancel your subsciption anytime you want. You can close your account via your dashboard. "
    },
    {
        id: 7,
        heading: "How are passwords stored?",
        content: "Passwords are cryptographically hashed within the cloud, which enables user management."
    },
    {
        id: 8,
        heading: "Is data stored on Webbermill products encrypted?",
        content: "Webbermill encrypts customer data in transit and at rest. All customer data stored within webbermill products and services is encrypted in transit over public networks using Transport Layer Security (TLS) 1.2+ with Perfect Forward Secrecy (PFS) to protect it from unauthorized disclosure or modification."
    },
    {
        id: 9,
        heading: "How can I book a demo of the software?",
        content: "If you would like to get a demo of the software, you can use our contact form to get in touch with us."
    }
]


export const Questions = [
    {
        title: "What makes our solution different from others?",
        text: "Our trip software is built on a reliable technology that makes it work seamlesly with proper security measures in place. All of our consultants have several years of experience within the oil industry and have a thorough understanding of its associated pains and needs. Additionally, our solutions are fully integrated, which makes your daily work stress-free and much more efficient."
    },
    {
        title: "Who owns my data, and is my data secure?",
        text: "We take data security seriously at Webbermill Limited. Our servers are hosted in a world-class data center that is protected by 24-hour surveillance, and we ensure that our application is always up to date with the latest security patches. Our partner's data centers are secure, and all our plans include SSL encryption to keep your data safe."
    },
    {
        title: "What support do I get?",
        text: "You can access our support by email or live chat in the application. We provide support and a robust community of help content to guide you through the use of our software. Click on “Support” in the footer navigation to access our knowledge base.  "
    },
    {
        title: "I need support during the weekend. Will I receive it?",
        text: "The weekend support is reserved only for Premium customers. We know that the weekend is commonly the best time to perform migrations or maintenance. Still, you will only get assistance from Webbermill support if you have a premium account (independently of the case’s priority). If you need help during the weekend, please get in touch with the Sales Team and upgrade your subscription right away!"
    },
    {
        title: "I’m not a technical person. Is this a problem?",
        text: "There is no problem with Webbermill Software not having technical skills. Customers are responsible for administering and setting up their own software. Webbermill Support will guide you on doing this. If you require further assistance, don’t hesitate to contact customer support."
    },
    {
        title: "Can I delete my account?",
        text: "Yes! You are free to delete your account or cancel your subsciption anytime you want. You can close your account via your dashboard. "
    },
    {
        title: "How are passwords stored?",
        text: "Passwords are cryptographically hashed within the cloud, which enables user management."
    },
    {
        title: "Is data stored on Webbermill products encrypted?",
        text: "Webbermill encrypts customer data in transit and at rest. All customer data stored within webbermill products and services is encrypted in transit over public networks using Transport Layer Security (TLS) 1.2+ with Perfect Forward Secrecy (PFS) to protect it from unauthorized disclosure or modification."
    },
    {
        title: "How can I book a demo of the software?",
        text: "If you would like to get a demo of the software, you can use our contact form to get in touch with us."
    },
    {
        title: 'Is there an iPhone, iPad, tablet and Android mobile app?',
        text: 'Currently, there is no mobile app for the Trip software. We are working on android and ios apps for the software, which will be rolled out soon. However, the software is easily accessible on an iPad or tablet device.'
    },
    {
        title: 'Does webbermill have a desktop app?',
        text: 'No. Webbermill has no desktop application. Most of our apps are web apps where you can log in and access your info anytime.'
    },
    {
        title: 'How do I log into my account?',
        text: 'To login to your account for the first time, go to your email address and open the invite you have received from your team. Pressing on the green ‘Accept Invitation’ button to proceed. Next, fill in your details: name, password. After pressing the checkbox to agree to the Terms of Service and Privacy Policy, press ‘Continue’, and you are good to go! '
    },
    {
        title: 'Can I pay monthly?',
        text: 'Yes! We offer monthly and yearly payment plans. Many of our customers prefer to go for yearly plans because they’re the most economical choice. But monthly is cool, too.'
    },
    {
        title: 'What happens to my data if I cancel?',
        text: 'Once you cancel your trial, you will be able to decide whether or not you would like to keep your account’s data to access it later or if you would like to delete it.'
    },
    {
        title: "I can’t log in to my account. What do I do?",
        text: 'If you’re having trouble logging in to your account, a few things might be happening. You have multiple tabs/account URLs; You’re using the wrong email address; You forgot your password.; or your account was deactivated. If you’ve figured out all of your login credentials and are still unable to log in, please get in touch with your account admin or customer support.'
    },
    {
        title: "How do I report bugs on webbermill.com?",
        text: 'No one is perfect, even us! Although we strive to make webbermill.com as polished as possible, sometimes there are bugs, and a bug means something is not working properly. At webbermill, we love to make data-informed decisions. We measure everything -  progress towards KPIs and performance. We know how important it is for any business to have detailed and accurate reporting. Reporting helps everyone understand how they are performing against their goals and discover places for improvement. In short, reporting shows us reality as well as opportunity. To report a bug, contact support.       '
    },

]

